/**
 * googleTagManager actions
 */
import { DISPATCH_EVENT, OH_WEB_EVENT } from './constants';

export function dispatchClickEvent(
    category: string,
    payload?: Record<string, any>
) {
    return {
        type: DISPATCH_EVENT,
        meta: {
            gtmVariables: {
                event: OH_WEB_EVENT,
                eventCategory: category,
                eventAction: 'Click',
                ...payload
            },
            googleTagManager: true
        }
    };
}
